import type { AxiosError } from 'axios';
import i18n from '@/lib/i18n';
import { getErrorMessage, translateErrorMessage } from '@/lib/errorTranslator';
import { CAREERS_INVALID_INPUT_MESSAGE, CAREERS_VALIDATION_FIELDS_PREFIX } from '../constants';

type ErrorBody = { error?: { message?: string; params?: Record<string, unknown> | null } };

/**
 * A failed careers request in the candidate's language. A validation error names its field
 * (params.field, as the server's schema calls it): that name is worded here; a field without a
 * wording falls back to the message that names none.
 */
export const careersErrorMessage = (error: unknown): string => {
  const body = (error as AxiosError<ErrorBody>)?.response?.data?.error;
  const field = body?.params?.field;
  if (body?.message && typeof field === 'string') {
    const labelKey = `${CAREERS_VALIDATION_FIELDS_PREFIX}.${field}`;
    if (!i18n.exists(labelKey)) return translateErrorMessage(CAREERS_INVALID_INPUT_MESSAGE);
    return translateErrorMessage(body.message, { ...body.params, field: i18n.t(labelKey) });
  }
  return getErrorMessage(error) || String(i18n.t('MESSAGES.GENERAL.INTERNAL_SERVER_ERROR'));
};
